import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import useChangePasswordPageStyles from './styles'
import { ChangePasswordNew } from '../../../../services/api'
import CustomAlert from '../../../../components/CustomAlert/CustomAlert'

const ChangePasswordPage = () => {
  const classes = useChangePasswordPageStyles()
  const token = localStorage.getItem('accessToken')
  const [oldPassword, setOldPassword] = useState('')
  const [password, setPassWord] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMessage, setalertMessage] = useState('')
  const [alertSeverity, setAlertSeverity] = useState('success')

  const handleChangepassword = () => {
    if (!oldPassword || !password || !confirmPassword) {
      setAlertOpen(true)
      setalertMessage('All fields are required')
      setAlertSeverity('error')
      return
    }

    if (password !== confirmPassword) {
      setAlertOpen(true)
      setalertMessage('Passwords do not match')
      setAlertSeverity('error')
      return
    }

    const data = {
      oldPassword: oldPassword,
      newPassword: password,
      confirmPassword: confirmPassword
    }

    ChangePasswordNew(data, token).then((resp) => {
      if (resp?.status === 200 || resp?.data?.message) {
        setAlertOpen(true)
        setalertMessage(resp?.data?.message || 'Password updated successfully')
        setAlertSeverity('success')
        setOldPassword('')
        setPassWord('')
        setConfirmPassword('')
      } else {
        setAlertOpen(true)
        setalertMessage(resp?.response?.data?.message || resp?.data?.message || 'Failed to update password')
        setAlertSeverity('error')
      }
    }).catch(err => {
      setAlertOpen(true)
      setalertMessage(err?.response?.data?.message || 'Error updating password')
      setAlertSeverity('error')
    })
  }

  const alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setAlertOpen(false)
  }
  return (
    <div className={classes.root}>
      <CustomAlert
        handleClose={alertClose}
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      <div className="align_btw brdr">
        <div className="h_1">Change Password</div>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="old-password"
              label="Old Password"
              variant="outlined"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="new-password"
              label="New Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassWord(e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="confirm-password"
              label="Confirm Password"
              variant="outlined"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </FormControl>
        </Grid>
      </Grid>

      <button className="save_btn" onClick={handleChangepassword}>
        Update
      </button>
    </div>
  )
}

ChangePasswordPage.propTypes = {}

export default ChangePasswordPage
